import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';

type Props = {
  trackingId?: string | null;
};

const GoogleAnalyticsPixels: React.FC<Props> = ({ trackingId }) => {
  useEffect(() => {
    if (!trackingId) {
      return;
    }
    ReactGA.initialize(trackingId);
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, [trackingId]);

  return null;
};

export default GoogleAnalyticsPixels;
